import { render } from "./city-delete.vue?vue&type=template&id=4f6ca8aa"
import script from "./city-delete.vue?vue&type=script&lang=js"
export * from "./city-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__